import { IBaseGetParams } from '../Global'
import { IBaseReducer } from '../BaseReducer'

export interface INotificationPreference {
  notification_type_id: number
  notification_type_name: string
  notification_type_description: string
  notification_channel_id: number
  notification_channel_name: string
  notification_type_position: number
  id: number
  status: 1
  is_editable: boolean
  notification_type?: INotificationType
  notification_channel?: INotificationChannel
}

export interface INotificationType {
  description: string
  id: number
  name: string
  status: number
}

export interface INotificationChannel {
  description: string
  id: number
  name: string
  status: number
}

export interface IGetNotificationPreferencesParams extends IBaseGetParams {
  status?: number
  user_id?: number
  role_id?: number
}

export interface IPostNotificationPreferenceParams {
  notification_channel_id: number
  notification_type_id: number
  status?: number
}

export type IPutNotificationPreferenceParams = INotificationPreferenceIncludeParams &
  IPutNotificationPreferenceParamsBase

export interface IPutNotificationPreferenceParamsBase {
  status: number
}

export interface INotificationPreferenceIncludeParams {
  include?:
    | {
        notification_type?: Record<any, any>
        notification_channel?: Record<any, any>
      }
    | ('notification_type' | 'notification_channel')[]
}

export interface INotificationPreferenceReducer
  extends IBaseReducer<INotificationPreference[]> {
  notificationPreference?: INotificationPreference
}

export enum NOTIFICATION_CHANNEL_NAME {
  TEXT = 'Text',
  SMS = 'Sms',
  EMAIL = 'Email',
  PUSH = 'Push',
}

export enum NOTIFICATION_PREFERENCE_STATUS {
  DISABLED,
  ENABLED,
}
